module.exports = __webpack_public_path__ + "right-author-next-7e655345.png";